$.fn.dataTable.ext.feature.push( {
	fnInit: function(settings) {
	    let sort = settings.oInit.selectSort

        if (!sort) {
            return ''
        }

        let api = new $.fn.dataTable.Api( settings );

	    let select = document.createElement('select')

        select.className = 'custom-select w-auto'

        sort.forEach(column => {
            let el1 = document.createElement('option')
            let el2 = document.createElement('option')

            el1.textContent = column.name_asc
            el2.textContent = column.name_desc

            el1.value = '+' + column.column
            el2.value = '-' + column.column

            select.append(el1, el2)
        })

        select.addEventListener('change', function() {
            let name = this.value.substring(1)

            let column = settings.aoColumns.find(col => col.sName === name)

            let order = this.value.substring(0,1) === '+' ? 'asc' : 'desc'

            api.order([column.idx, order]).ajax.reload()
        })

        api.on('order.dt', function(e, settings, ordArr) {
            let column = settings.aoColumns.find(col => col.idx === ordArr[0].col)

            let dir = ordArr[0].dir === 'asc' ? '+' : '-'

            select.value = dir + column.sName
        })

	    return $('<div/>').addClass(['dt-sorting']).append(select)
    },
	cFeature: "S"
} );
